import { useQuery } from '@tanstack/react-query'
import {
  Navigate,
  Outlet,
  createFileRoute,
  redirect,
} from '@tanstack/react-router'

import { querySession } from '@api/session/session.queries'

export const Route = createFileRoute('/session')({
  component: RouteComponent,
  // Redirect logged in user to app
  beforeLoad: ({ context: { session } }) => {
    if (session) throw redirect({ to: '/app' })
  },
})

function RouteComponent() {
  // When loading this page directly, the beforeLoad function
  // will receive a null session, because the query has not
  // resolved yet, so we need to check it here too.
  const { data: session } = useQuery(querySession())

  if (session) return <Navigate to="/app" />

  return (
    <div
      className="relative flex h-screen w-screen items-start justify-center overflow-y-auto"
      style={{
        background:
          'linear-gradient(300deg,rgba(239, 236, 226, 1) 39%, rgba(241, 248, 244, 1) 53%, rgba(217, 240, 248, 1) 70%)',
      }}
    >
      <img
        src="/images/home/charts-drawer.png"
        className="absolute right-0 bottom-10"
      />
      <div className="z-10 flex w-full flex-col items-center gap-23.5 pt-17.75">
        <Route.Link to="./login">
          <img
            src="/images/fibus-digital-logo.svg"
            className="max-w-28.5 cursor-pointer"
          />
        </Route.Link>
        <Outlet />
      </div>
    </div>
  )
}
